import { isEqual } from 'lodash'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type {
  EditorSDK,
  DynamicPageRouterData,
} from '@wix/wix-data-client-common-standalone'
import type { RouterConfig } from '@wix/wix-data-client-common'

export const getPageRouter = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}): Promise<DynamicPageRouterData | undefined> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()
  return routers.find(({ pages }) =>
    pages.some(({ pageRef: testPageRef }) => isEqual(testPageRef, pageRef)),
  )
}
